import React, { useEffect } from 'react';

const Toast = ({ id, message, type = 'info', onClose, duration = 2500 }) => {
  useEffect(() => {
    const t = setTimeout(() => onClose(id), duration);
    return () => clearTimeout(t);
  }, [id, onClose, duration]);

  return (
    <div className={`vc-toast ${type}`} role="status" aria-live="polite">
      {message}
    </div>
  );
};

export default function ToastStack({ toasts, onClose }) {
  return (
    <div className="vc-toast-stack">
      {toasts.map(t => (
        <Toast key={t.id} {...t} onClose={onClose} />)
      )}
    </div>
  );
}
